import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'

const CFCreateModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    createMode, updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    //
    year, onYearChange, yearError, setYearError, yearList,
    month, onMonthChange, monthError, setMonthError, monthList,
    loanAmount, onLoanAmountChange, loanAmountError, setLoanAmountError,
    promoterFund, onPromoterFundChange, promoterFundError, setPromoterFundError,
    dsraAmount, onDsraAmountChange, dsraAmountError, setDsraAmountError,
    processingFee, onProcessingFeeChange, processingFeeError, setProcessingFeeError,
    emiPayment, onEmiPaymentChange, emiPaymentError, setEmiPaymentError,
    projectExpense, onProjectExpenseChange, projectExpenseError, setProjectExpenseError,
    climeRevenue, onClimeRevenueChange, climeRevenueError, setClimeRevenueError,
    otherRevenue, onOtherRevenueChange, otherRevenueError, setOtherRevenueError,
    notes, onNotesChange, notesError, setNotesError
  }) =>
  <ModalFormUI
    context={context}
    titleLabel= {createMode ? 'Add cash flow' : 'Update cash flow'}
    buttonLabel='Add'
    cancelLabel='Cancel'
    isOpen={createMode || updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
  <div className='g_flex_h g_flex_top'>
    <div>
    <InputSelectUI name='year' value={year} required={true} label='Year'
      optionList={yearList} onChange={onYearChange} error={yearError}
    />
    <InputSelectUI name='month' value={month} required={true} label='Month'
      optionList={monthList} onChange={onMonthChange} error={monthError}
    />
    <InputTextSF type='text'  name='loanAmount' label='Loan amount'
      required={true} maxLength={10}
      value={loanAmount} onChange={onLoanAmountChange}
      error={loanAmountError} setError={setLoanAmountError}
    />
    <InputTextSF type='text'  name='promoterFund' label='Promoter fund'
      required={true} maxLength={10}
      value={promoterFund} onChange={onPromoterFundChange}
      error={promoterFundError} setError={setPromoterFundError}
    />
    <InputTextSF type='text'  name='dsraAmount' label='DSRA amount'
      required={true} maxLength={10}
      value={dsraAmount} onChange={onDsraAmountChange}
      error={dsraAmountError} setError={setDsraAmountError}
    />
    <InputTextSF type='text'  name='processingFee' label='Processing fee'
      required={true} maxLength={10}
      value={processingFee} onChange={onProcessingFeeChange}
      error={processingFeeError} setError={setProcessingFeeError}
    />
  </div>
  <div className='g_m_left_100'>
    <InputTextSF type='text'  name='emiPayment' label='Emi payment'
      required={true} maxLength={10}
      value={emiPayment} onChange={onEmiPaymentChange}
      error={emiPaymentError} setError={setEmiPaymentError}
    />
    <InputTextSF type='text'  name='projectExpense' label='Projected payments'
      required={true} maxLength={10}
      value={projectExpense} onChange={onProjectExpenseChange}
      error={projectExpenseError} setError={setProjectExpenseError}
    />
    <InputTextSF type='text'  name='climeRevenue' label='Clime collections'
      required={true} maxLength={10}
      value={climeRevenue} onChange={onClimeRevenueChange}
      error={climeRevenueError} setError={setClimeRevenueError}
    />
    <InputTextSF type='text'  name='otherRevenue' label='Other collections'
      required={true} maxLength={10}
      value={otherRevenue} onChange={onOtherRevenueChange}
      error={otherRevenueError} setError={setOtherRevenueError}
    />
    <InputTextAreaSF type='text' name='notes' maxLength={10}
      label='Notes'
      value={notes} onChange={onNotesChange}
      error={notesError} setError={setNotesError}
      help='Type "delete" to delete this record'
    />
  </div>
</div>
  </ModalFormUI>

export default CFCreateModalUI
